const cnpj = (str: string) =>
    str
        .replace(/\D/g, '')
        .replace(/(\d{2})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d{1,4})/, '$1/$2')
        .replace(/(\/\d{4})(\d{1,2})/, '$1-$2')
        .replace(/(-\d{2})\d+?/, '$1')

const cpf = (str: string) =>
    str
        .replace(/\D/g, '')
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d{1,2})/, '$1-$2')
        .replace(/(-\d{2})\d+?/, '$1')

const cep = (str: string | null | undefined) => {
    if (!str) {
        return '';
    }

    str
    .replace(/\D/g, '')
    .replace(/(\d{5})(\d)/, '$1-$2')
    .replace(/(-\d{3})(\d+?)/, '$1')

    return str
}

const telefone = (str: string) =>
    str
        .replace(/\D/g, '')
        .replace(/(\d{2})(\d)/, '($1) $2')
        .replace(/(\d{4})(\d)/, '$1-$2')
        .replace(/(-\d{4})(\d+?)/, '$1')

const celular = (str: string) =>
    str
        .replace(/\D/g, '')
        .replace(/(\d{2})(\d)/, '($1) $2')
        .replace(/(\d{1})(\d{4})(\d)/, '$1 $2-$3')
        .replace(/(-\d{4})(\d+?)/, '$1')

const contato = (str: string) => {
    const value = str.replace(/\D/g, '')
    return value.length > 10 ? celular(value) : telefone(value)
}

const registro = (str: string) => {
    const value = str.replace(/\D/g, '')
    return value.length > 11 ? cnpj(value) : cpf(value)
}

const data = (str: string | null | undefined): string => {
    if (!str) {
        return '';
    }

    if (!Number.isNaN(new Date(str).getTime())) {
        const data = new Date(str)

        const formatData = `${data.getUTCDate().toString().padStart(2, '0')}/${(
            data.getUTCMonth() + 1
        )
            .toString()
            .padStart(2, '0')}/${data.getUTCFullYear()}`
        return formatData
    } else {
        return ''
    }
}

const formatWithLeadingZero = (val: number) => (val < 10 ? `0${val}` : val)

const dataWithHour = (str: string) => {
    if (!Number.isNaN(new Date(str).getTime())) {
        const data = new Date(str)
        const formatData = `${data.getUTCDate().toString().padStart(2, '0')}/${(
            data.getUTCMonth() + 1
        )
            .toString()
            .padStart(2, '0')}/${data.getUTCFullYear()}`

        const formatTime = `${formatWithLeadingZero(
            data.getHours()
        ).toString()}:${formatWithLeadingZero(
            data.getMinutes()
        ).toString()}:${formatWithLeadingZero(data.getSeconds()).toString()}`

        return formatData + ' - ' + formatTime
    } else {
        return ''
    }
}

const timeConverter = (UNIX_timestamp: string) => {
    const date = new Date(UNIX_timestamp)
    const year = date.toLocaleString('default', { year: 'numeric' })
    const month = date.toLocaleString('default', { month: '2-digit' })
    const day = date.toLocaleString('default', { day: '2-digit' })

    const formattedDate = year + '-' + month + '-' + day

    return formattedDate
}

const formatDateToEn = (dateString: string) => {
    const [day, month, year] = dateString.split('/')
    return `${year}-${month}-${day}`
}

const firstLatterUppercase = (str: string) => {
    return str
        ?.toLowerCase()
        ?.replace(/^(.)|\s+(.)/g, letter => letter.toUpperCase())
}

const transformInitals = (data: string | null) => {
    if (!data) return '-'

    return data
        ?.match(/(^\S\S?|\s\S)?/g)
        ?.map(v => v.trim())
        ?.join('')
        ?.match(/(^\S|\S$)?/g)
        ?.join('')
        .toLocaleUpperCase() as string
}

const clearCharacters = (str: string) => {
    return str
        .normalize('NFD')
        .replace(/[^0-9a-zA-Z\s+]+/g, '')
        .replace(/( )+/g, ' ')
}

const cleanFormatter = (str: string) => {
    return str.replace(/[^\d]+/g, '')
}

const checkZero = (percentOrCurrency: string) => {
    const removeEncode = percentOrCurrency.replace(/\u00A0/, ' ')
    const checkEmpty = removeEncode === '0,000%' || removeEncode === 'R$ 0,00'
    if (checkEmpty) {
        return ''
    } else {
        return percentOrCurrency
    }
}
const moeda = (str: string | number | null | undefined): string => {
    if (!str) {
        return '';
    }

    const formatter = new Intl.NumberFormat('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
        style: 'currency',
        currency: 'BRL'
    })

    if (typeof str === 'number') {
        return formatter.format(str).toString()
    } else {
        const clearValue = String(str).replace(/\D+/g, '')

        if (clearValue === '0' || clearValue === '') {
            return formatter.format(0).toString()
        }

        const dealsCurrency = formatter
            .format(parseInt(clearValue) / 100)
            .toString()
        return dealsCurrency
    }
}

const toCamelCase = (str: string) => {
    return str
        .toLowerCase() // Convert to lowercase first
        .replace(
            /(?:^\w|[A-Z]|\b\w|\s+)/g,
            match =>
                match.trim().charAt(0).toUpperCase() +
                match.slice(1).toLowerCase()
        )
}

const formatDateToYearMonthDay = (date: string) => {
    if (!date) return
    const delimiter = date.includes('/') ? '/' : '-'

    const [day, month, year] = date.split(delimiter)

    if (!day || !month || !year) {
        throw new Error('Invalid date format')
    }

    const formattedDate = `${year}-${month}-${day}`
    return formattedDate
}

const formatDateToPayload = (date: string | null): string => {
    if (!date) return ''

    const isValidIsoDate = /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/.test(
        date
    )
    if (isValidIsoDate) return date

    return formatter.timeConverter(date)
}

const percentual = (str: string | number | null | undefined): string => {
    if (!str) {
        return '';
    }

    const perc =
        !String(str).includes('%') && String(str).length > 1
            ? String(str).slice(0, -1)
            : String(str)

    const formatter = new Intl.NumberFormat('pt-BR', {
        style: 'percent',
        minimumFractionDigits: 3,
        maximumFractionDigits: 3
    })

    if (typeof str === 'number') {
        return formatter.format(str / 100)
    } else {
        const clearValue = perc.replace(/\D+/g, '')
        const dealsPercentage = clearValue
            ? formatter.format(parseInt(clearValue) / 100000).toString()
            : ''
        const formattedPercent = checkZero(dealsPercentage)
        return formattedPercent
    }
}

const placa = (str: string | null) => {
    if (str === null) return ''
    const rpl = str
        .replace(/\W/g, '')
        .match(
            /^(\D{1,3})(\d{1})([0-9A-Za-z]{1})(\d{1,2})$|^(\D{1,3})$|^(\D{3})(\d{1})$|^(\D{3})(\d{1})([0-9A-Za-z]{1})$/
        )

    if (str.replace(/\W/g, '').length > 8 && !rpl) {
        return ''
    }
    if (!rpl) {
        return str.slice(0, -1)
    } else {
        const data = str.replace(/\W/g, '').charAt(4).match(/\d/)
            ? str
                  .replace(/\W/g, '')
                  .replace(/^(\D{3})(\d)/g, '$1-$2')
                  .replace(/(-\d{4})(\d+?)/g, '$1')
                  .toUpperCase()
            : str
                  .replace(/\W/g, '')
                  .replace(/^(\D{3})(\d)/g, '$1$2')
                  .replace(/(\d{1})(\D{1})(\d)/g, '$1$2$3')
                  .replace(/(\d{2})(\d+?)/g, '$1')
                  .toUpperCase()

        return data
    }
}

const operationName = (typeContract: string) => {
    switch (typeContract) {
        case 'INCLUSAO_REGISTRO':
            return 'Registro de Contrato'

        case 'ALTERACAO_REGISTRO':
            return 'Alteração de Contrato'

        case 'INCLUSAO_ADITIVO':
            return 'Registro de Aditivo'

        case 'ALTERACAO_ADITIVO':
            return 'Alteração de Aditivo'

        default:
            break
    }
}

const operationNameReverse = (typeContract: string) => {
    switch (typeContract) {
        case 'INCLUSAO_REGISTRO':
            return 'CREATE'

        case 'ALTERACAO_REGISTRO':
            return 'UPDATE'

        case 'INCLUSAO_ADITIVO':
            return 'ADDITIVE'

        case 'ALTERACAO_ADITIVO':
            return 'EDITADDITIVE'

        default:
            break
    }
}

const convertCategory = (typeContract: string) => {
    switch (typeContract) {
        case 'BANCOS':
            return 'Bancos'

        case 'FINANCEIRAS':
            return 'Financeiras'

        case 'EMPRESAS_LEASING':
            return 'Empresas de Leasing'

        case 'ADMINISTRADORAS_CONSORCIOS':
            return 'Administradoras de Consórcios'

        case 'DESPACHANTES':
            return 'Despachantes'            

        default:
            return '-'
    }
}

const onlyNumber = (str: string) => str.replace(/\D/g, '')

const formatter = {
    cep,
    cnpj,
    cpf,
    registro,
    celular,
    telefone,
    contato,
    data,
    dataWithHour,
    moeda,
    percentual,
    placa,
    firstLatterUppercase,
    clearCharacters,
    cleanFormatter,
    transformInitals,
    operationName,
    operationNameReverse,
    onlyNumber,
    convertCategory,
    timeConverter,
    formatDateToEn,
    formatWithLeadingZero,
    formatDateToYearMonthDay,
    toCamelCase,
    formatDateToPayload
}

export default formatter
